module.exports = __webpack_public_path__ + "img/trello.3f3b66ab.png";